<template>
  <van-popup
    v-model:show="freeCardPopupConfig.isShow"
    position="center"
    class="free-card-popup"
    teleport="body"
  >
    <div class="free-card-content">
      <img
        class="card-title"
        src="@/assets/image/freeCardPopup/titile.png"
        alt=""
      />
      <img
        class="card-img"
        src="@/assets/image/freeCardPopup/free-card.png"
        alt=""
      />
      <div class="content">
        {{ $t('match.FreeCardPopupTitle', [freeCardNum]) }}
      </div>
      <van-button class="btn" @click="handleToMatch">
        {{ $t('match.FreeCardPopupBtn') }}
      </van-button>
    </div>
  </van-popup>
</template>

<script setup lang="ts">
// 公共模块store
const publicStore = usePublicStore()
const { freeCardPopupConfig } = storeToRefs(publicStore)

// 监听路由，切换页面关闭弹窗
const router = useRouter()
router.afterEach(() => {
  publicStore.setShowFreeCardPopup(false)
})

//callStore
const callStore = useCallStore()

const freeCardNum = ref(0)
watch(
  () => freeCardPopupConfig.value.isShow,
  () => {
    // 只在登录后才显示，所以直接拿缓存的数量就好了
    if (freeCardPopupConfig.value.isShow && localStorage.getItem('loginInfo')) {
      const loginInfo = JSON.parse(localStorage.getItem('loginInfo') as string)
      freeCardNum.value = loginInfo.freeCard
    }
  }
)

function handleToMatch() {
  publicStore.setShowFreeCardPopup(false)
  // 去匹配
  callStore.match(1)
}
</script>

<style lang="scss">
.free-card-popup {
  padding-top: 80px;
  width: 278px;
  background-color: transparent;
  text-align: center;
  .free-card-content {
    padding-bottom: 18px;
    width: 278px;
    background: linear-gradient(180deg, #261800 0%, #4a2d10 100%);
    border-radius: 20px;
    backdrop-filter: blur(2px);
  }
  .card-title {
    margin-top: -136px;
    @include wh(190px, 24px);
  }
  .card-img {
    margin-top: -74px;
    @include wh(163px, 150px);
  }
  .content {
    padding: 0 20px;
    @include font-style(16px, #fff2e3);
    font-weight: 500;
  }

  .btn {
    display: block;
    margin: 24px auto 0;
    @include wh(181px, 43px);
    background: linear-gradient(136deg, #ff005a 0%, #feca07 100%);
    border-radius: 26px;
    @include font-style(16px, #fff);
    border: none;
    font-weight: bold;
  }
}
</style>
